"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInteractor = exports.useRib = void 0;
const react_1 = require("react");
const hooks_1 = require("../hooks");
const model_1 = require("../model");
const isViewableRouting = (router) => {
    return (Object.hasOwnProperty.call(router, 'viewController') &&
        router.viewController &&
        typeof router.viewController.render === 'function');
};
const useRib = (configure) => {
    const { getErrorListener } = (0, hooks_1.useAppContext)();
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const ribRef = (0, react_1.useRef)(configure().build());
    const unmountRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        const { router } = ribRef.current;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield router.load();
            }
            catch (err) {
                getErrorListener().onCatchError(err);
            }
            if (!unmountRef.current) {
                setLoaded(true);
            }
        }))();
        return () => {
            unmountRef.current = true;
            try {
                router.unload();
            }
            catch (err) {
                getErrorListener().onCatchError(err);
            }
        };
    }, []);
    return {
        element: isViewableRouting(ribRef.current.router)
            ? ribRef.current.router.viewController.render()
            : null,
        actionable: ribRef.current.actionable,
        loaded
    };
};
exports.useRib = useRib;
function useInteractor(builder, { autoActivate = true } = {}) {
    const metaModelRef = (0, react_1.useRef)(null);
    if (!metaModelRef.current) {
        metaModelRef.current = new model_1.Model({ activated: false });
    }
    const iRef = (0, react_1.useRef)(null);
    if (!iRef.current) {
        iRef.current = builder();
    }
    const activate = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        yield ((_a = iRef.current) === null || _a === void 0 ? void 0 : _a.activate());
        (_b = metaModelRef.current) === null || _b === void 0 ? void 0 : _b.update((value) => {
            value.activated = true;
        });
    });
    const deactivate = () => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        yield ((_c = iRef.current) === null || _c === void 0 ? void 0 : _c.deactivate());
        (_d = metaModelRef.current) === null || _d === void 0 ? void 0 : _d.update((value) => {
            value.activated = false;
        });
    });
    (0, react_1.useEffect)(() => {
        if (autoActivate) {
            activate().catch((err) => {
                console.error(err);
            });
        }
        return () => {
            deactivate()
                .then(() => {
                var _a;
                (_a = metaModelRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
            })
                .catch((err) => {
                console.error(err);
            });
        };
    }, []);
    return {
        interactor: iRef.current,
        meta: metaModelRef.current,
        activate,
        deactivate
    };
}
exports.useInteractor = useInteractor;
//# sourceMappingURL=hooks.js.map